import styled from "styled-components";

export const PageWrapper = styled.div`
  background: #1A1814;
  min-height: 100vh;
  overflow-x: hidden;
`;

export const HeroSection = styled.section`
  padding: 120px 64px 60px;
  position: relative;

  @media (max-width: 1024px) {
    padding: 100px 36px 40px;
  }

  @media (max-width: 768px) {
    padding: 80px 24px 32px;
  }
`;

export const BackLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(216, 208, 195, 0.3);
  border-radius: 8px;
  color: #BDB3A3;
  font-size: 0.9375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 32px;

  &:hover {
    background: rgba(216, 208, 195, 0.1);
    border-color: rgba(216, 208, 195, 0.5);
    color: #F3ECE1;
  }
`;

export const HeroContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 64px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 48px;
  }
`;

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ProductTag = styled.div`
  display: inline-block;
  padding: 8px 16px;
  background: rgba(217, 68, 43, 0.15);
  border: 1px solid rgba(217, 68, 43, 0.3);
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #D9442B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: fit-content;
`;

export const ProductTitle = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  color: #F3ECE1;
  line-height: 1.1;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 2.75rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const ProductSubtitle = styled.p`
  font-size: 1.25rem;
  color: #BDB3A3;
  line-height: 1.6;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.125rem;
  }
`;

export const ProductDescription = styled.div`
  font-size: 1.0625rem;
  color: #BDB3A3;
  line-height: 1.8;
  white-space: pre-line;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const PurchaseCard = styled.div`
  position: sticky;
  top: 100px;
  background: rgba(26, 24, 20, 0.8);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(217, 68, 43, 0.3);
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1024px) {
    position: relative;
    top: 0;
  }

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

export const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 16px;
`;

export const CurrentPrice = styled.div`
  font-size: 3rem;
  font-weight: 700;
  color: #F3ECE1;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const FuturePrice = styled.div`
  font-size: 1.5rem;
  color: #8A8276;
  text-decoration: line-through;
`;

export const FoundingPriceNotice = styled.div`
  padding: 12px 16px;
  background: rgba(217, 68, 43, 0.1);
  border: 1px solid rgba(217, 68, 43, 0.3);
  border-radius: 8px;
  font-size: 0.9375rem;
  color: #BDB3A3;
  line-height: 1.5;

  strong {
    color: #D9442B;
    font-weight: 600;
  }
`;

export const IncludedSection = styled.div`
  padding-top: 20px;
  border-top: 1px solid rgba(216, 208, 195, 0.3);
`;

export const IncludedTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #F3ECE1;
  margin-bottom: 16px;
`;

export const IncludedList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const IncludedItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.9375rem;
  color: #BDB3A3;
  line-height: 1.5;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: #D9442B;
  }
`;

export const AcknowledgmentCheckbox = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: rgba(216, 208, 195, 0.05);
  border: 1px solid rgba(216, 208, 195, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(216, 208, 195, 0.1);
    border-color: rgba(216, 208, 195, 0.3);
  }

  input {
    margin-top: 3px;
    cursor: pointer;
  }

  span {
    font-size: 0.875rem;
    color: #BDB3A3;
    line-height: 1.5;
  }
`;

export const PurchaseButton = styled.button<{ $disabled: boolean }>`
  width: 100%;
  padding: 16px 24px;
  background: ${props => props.$disabled
    ? 'rgba(138, 130, 118, 0.5)'
    : 'linear-gradient(135deg, #D9442B 0%, #F5D9CC 100%)'};
  color: #F3ECE1;
  border: none;
  border-radius: 8px;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: ${props => props.$disabled ? 0.6 : 1};

  &:hover {
    ${props => !props.$disabled && `
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(217, 68, 43, 0.4);
    `}
  }

  &:active {
    ${props => !props.$disabled && 'transform: translateY(0);'}
  }
`;

export const SecureNotice = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 0.8125rem;
  color: #8A8276;

  svg {
    color: #D9442B;
  }
`;

export const ContentSection = styled.section`
  padding: 80px 64px;
  position: relative;

  @media (max-width: 1024px) {
    padding: 60px 36px;
  }

  @media (max-width: 768px) {
    padding: 48px 24px;
  }
`;

export const ContentContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #F3ECE1;
  margin-bottom: 40px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 32px;
  }
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 48px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FeatureCard = styled.div`
  background: rgba(26, 24, 20, 0.6);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(216, 208, 195, 0.2);
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(217, 68, 43, 0.5);
    background: rgba(26, 24, 20, 0.8);
  }

  svg {
    flex-shrink: 0;
    color: #D9442B;
    margin-top: 4px;
  }
`;

export const FeatureText = styled.p`
  font-size: 1rem;
  color: #BDB3A3;
  line-height: 1.6;
  margin: 0;
`;

export const WhatYouGetGrid = styled.div`
  display: grid;
  gap: 32px;
`;

export const WhatYouGetItem = styled.div`
  background: rgba(26, 24, 20, 0.6);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(216, 208, 195, 0.2);
  border-radius: 12px;
  padding: 32px;
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(217, 68, 43, 0.5);
    background: rgba(26, 24, 20, 0.8);
    transform: translateY(-2px);
  }
`;

export const WhatYouGetTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: #F3ECE1;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const WhatYouGetDescription = styled.p`
  font-size: 1rem;
  color: #BDB3A3;
  line-height: 1.6;
  margin: 0;
`;
